export default __webpack_public_path__ + "static/collage-3fe0d980c5f5ec48ac328376582aa2c7.png";